(() => {
  if (customElements.get('leivip-videos-page')) return;
  class LeivipVideosPage extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const modal = this.querySelector('.video-modal');
        if (!modal) return;
        const stage = modal.querySelector('.video-stage');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const restore = () => {
          stage.replaceChildren();
          if (!this.saved) return;
          const saved = this.saved;
          this.saved = null;
          document.body.style.cssText = saved.body;
          window.scrollTo(0, saved.y);
          if (saved.trigger.isConnected) saved.trigger.focus({ preventScroll: true });
          document.documentElement.style.scrollBehavior = saved.scroll;
        };
        this.restore = restore;
        this.modal = modal;
        this.addEventListener('click', event => {
          const button = event.target.closest('.video-trigger');
          if (!button || !this.contains(button) || modal.open) return;
          const id = button.dataset.video;
          if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
          this.saved = { trigger: button, y: window.scrollY, body: document.body.style.cssText, scroll: document.documentElement.style.scrollBehavior };
          document.documentElement.style.scrollBehavior = 'auto';
          document.body.style.position = 'fixed';
          document.body.style.top = `-${this.saved.y}px`;
          document.body.style.width = '100%';
          const frame = document.createElement('iframe');
          frame.title = button.dataset.title;
          frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          frame.allowFullscreen = true;
          frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
          stage.replaceChildren(frame);
          modal.showModal();
          modal.querySelector('.video-close').focus();
        }, options);
        modal.querySelector('.video-close').addEventListener('click', () => modal.close(), options);
        modal.addEventListener('close', restore, options);
        modal.addEventListener('click', event => {
          if (event.target !== modal) return;
          const r = modal.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close();
        }, options);
      });
    }
    disconnectedCallback() {
      if (this.modal?.open) this.modal.close();
      this.restore?.();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('leivip-videos-page', LeivipVideosPage);
})();
